const normalizeNamePart = (value: string | undefined): string => value?.trim() ?? '';

const trimTrailingDots = (value: string): string => {
  let end = value.length;
  while (end > 0 && value.charAt(end - 1) === '.') {
    end -= 1;
  }
  return value.slice(0, end);
};

export const formatPassengerName = (
  title?: string,
  firstName?: string,
  lastName?: string,
): string => {
  const name = [firstName, lastName].map(normalizeNamePart).filter(Boolean).join(' ');
  const normalizedTitle = trimTrailingDots(normalizeNamePart(title));

  return normalizedTitle ? `${normalizedTitle}. ${name}`.trim() : name;
};
